import { render, staticRenderFns } from "./index.vue?vue&type=template&id=648bd782"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648bd782')) {
      api.createRecord('648bd782', component.options)
    } else {
      api.reload('648bd782', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=648bd782", function () {
      api.rerender('648bd782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/reportTab/postage/index.vue"
export default component.exports